import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface CheckboxProps {
    register: UseFormRegisterReturn;
    label: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ register, label }) => {
    return (
        <div className="form-check">
            <input
                type="checkbox"
                className="form-check-input"
                {...register}
            />
            <label className="form-check-label">{label}</label>
        </div>
    );
};

export default Checkbox;
